import { render, staticRenderFns } from "./Box3D.vue?vue&type=template&id=6bd514cc&scoped=true&"
import script from "./Box3D.vue?vue&type=script&lang=js&"
export * from "./Box3D.vue?vue&type=script&lang=js&"
import style0 from "./Box3D.vue?vue&type=style&index=0&id=6bd514cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd514cc",
  null
  
)

export default component.exports